import { takeEvery, put, call } from 'redux-saga/effects';

import { URL_API } from '../../common/constants/common.js';
import { HttpConnection } from '../../common/helper/http-connection.js'
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* getChunkList(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getChunkList',
        parameter: {
            id: action.subjectID,
            admin: action.admin
        },
    }
    const data = yield call(http.post, info);
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.items);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getChunkList",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getChunkListSaga = takeEvery('GetChunkList_Saga', getChunkList);

function* setChunk(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/setChunk',
        parameter: {
            id: action.chunk.id,
            subjectID: action.chunk.subjectID,
            textEn: action.chunk.textEn,
            textJp: action.chunk.textJp,
            order: action.chunk.order,
            check: action.chunk.check,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.id);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "setChunk",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const setChunkSaga = takeEvery('SetChunk_Saga', setChunk);

function* deleteChunk(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/deleteChunk',
        parameter: {
            id: action.id,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(action.id);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "deleteChunk",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const deleteChunkSaga = takeEvery('DeleteChunk_Saga', deleteChunk);
